/**
 * 목록 화면 공통 기간 프리셋 — 작업요청 목록·현장보고 목록·공사현황에서 **동일하게** 적용한다.
 * 칩 종류·순서·라벨과 기간 계산을 이 한 곳에서 소유해, 화면마다 어긋나지 않게 한다(SSOT).
 */

/** 기간 프리셋 키. 최근 7일 / 이번주 / 이번달 / 지난달. */
export type DatePreset = '7d' | 'tw' | 'tm' | 'lm';

/** 칩 렌더 순서·라벨(통일). 각 화면은 이 배열을 map 해서 칩을 그린다. */
export const DATE_PRESETS: readonly (readonly [DatePreset, string])[] = [
  ['7d', '최근 7일'],
  ['tw', '이번주'],
  ['tm', '이번달'],
  ['lm', '지난달'],
] as const;

/**
 * 프리셋 → 시작~종료 Date.
 * - 최근 7일 / 이번주(월요일~) / 이번달(1일~): 종료 = 오늘
 * - 지난달: 지난달 1일 ~ 지난달 말일 (종료도 지난달 말일)
 */
export function presetRange(preset: DatePreset): { from: Date; to: Date } {
  const to = new Date();
  const from = new Date();
  if (preset === '7d') {
    from.setDate(to.getDate() - 6);
    return { from, to };
  }
  if (preset === 'tw') {
    const dow = (to.getDay() + 6) % 7; // 월=0
    from.setDate(to.getDate() - dow);
    return { from, to };
  }
  if (preset === 'tm') {
    from.setDate(1);
    return { from, to };
  }
  // 'lm' 지난달 — 지난달 1일 ~ 말일 (JS Date가 월 언더플로를 정규화하므로 연말 경계도 안전)
  const y = to.getFullYear();
  const m = to.getMonth();
  return { from: new Date(y, m - 1, 1), to: new Date(y, m, 0) };
}
